import { tokens } from "shared/components/Spor";
import {
  PlanEventInformation,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { FC, MutableRefObject, useRef } from "react";
import styled from "styled-components";
import {
  MEASURE_OVERVIEW_BREAKPOINT,
  MeasureList,
} from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureList";
import {
  BottomScrollButtonsContainer,
  ScrollButtons,
  TopScrollButtonsContainer,
} from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/ScrollButtons";

const ColumnWrapper = styled.div`
  display: grid;
  grid-row: 1 / -1;
  grid-template-rows: subgrid;

  position: relative;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};

  & > ${TopScrollButtonsContainer}, & > ${BottomScrollButtonsContainer} {
    position: sticky;
    grid-column: 1 / -1;
    justify-self: center;
  }

  & > ${TopScrollButtonsContainer} {
    // Header is sticky, we want the buttons to appear below it
    top: calc(56px + ${tokens.default.size.spacing[3]});
    grid-row: 1;

    @container (width >= ${MEASURE_OVERVIEW_BREAKPOINT}) {
      // Ensure each button is placed in its respective column on wide screens
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-self: stretch;
      justify-items: center;
    }
  }

  & > ${BottomScrollButtonsContainer} {
    // The box has 0 height but the button inside it is 36px tall,
    // so we need to add that for the button to be placed properly
    bottom: calc(36px + ${tokens.default.size.spacing[3]});
    grid-row: -1;
  }
`;

const ListWrapper = styled.div`
  display: grid;
  height: 100%;
  grid-row: content-start / content-end;

  @container (width < ${MEASURE_OVERVIEW_BREAKPOINT}) {
    grid-template-rows: subgrid;
  }

  @container (width >= ${MEASURE_OVERVIEW_BREAKPOINT}) {
    grid-template-columns: 1fr 1fr;
  }
`;

type MeasureOverviewColumnProps = {
  measureKey: PlanMeasureKey;
  infraMeasures: PlanEventInformation[] | undefined;
  trainMeasures: PlanEventInformation[] | undefined;
  rootRef: MutableRefObject<HTMLElement | null>;
};

export const MeasureOverviewColumn: FC<MeasureOverviewColumnProps> = ({
  measureKey,
  infraMeasures,
  trainMeasures,
  rootRef,
}) => {
  const infraScrollRef = useRef<HTMLDivElement | null>(null);
  const trainScrollRef = useRef<HTMLDivElement | null>(null);

  return (
    <ColumnWrapper>
      <ListWrapper>
        <MeasureList
          measures={infraMeasures}
          measureKey={measureKey}
          title="Infrastruktur"
          scrollRef={infraScrollRef}
        />
        <MeasureList
          measures={trainMeasures}
          measureKey={measureKey}
          title="Tog"
          scrollRef={trainScrollRef}
        />
      </ListWrapper>

      <ScrollButtons
        measureKey={measureKey}
        infraScrollRef={infraScrollRef}
        trainScrollRef={trainScrollRef}
        rootRef={rootRef}
      />
    </ColumnWrapper>
  );
};
